import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import InputGroup from '@panneau/field-input-group';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

var useCKEditorBuild = function useCKEditorBuild() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var ref = useRef(null);
  useEffect(function () {
    var canceled = false;
    if (loaded) {
      return function () {
        canceled = true;
      };
    }
    import('@panneau/ckeditor/build').then(function (_ref) {
      var _ref$Editor = _ref.Editor,
        Editor = _ref$Editor === void 0 ? null : _ref$Editor;
      if (!canceled) {
        ref.current = Editor;
        setLoaded(true);
      }
    })
    // eslint-disable-next-line no-console
    ["catch"](function (e) {
      return console.log('err loading editor', e);
    });
    return function () {
      canceled = true;
    };
  }, [loaded, setLoaded]);
  return ref.current;
};

var styles = {"container":"panneau-field-html-container"};

var propTypes = {
  feedback: PropTypes.oneOf(['valid', 'invalid', 'loading']),
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  value: PropTypes.string,
  placeholder: PropTypes.string,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  ckConfig: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  ckOptions: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string
};
var defaultProps = {
  feedback: null,
  errors: null,
  value: null,
  placeholder: null,
  inline: false,
  disabled: false,
  onChange: null,
  onFocus: null,
  onBlur: null,
  ckConfig: {
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'
    // 'blockQuote',
    // 'mediaEmbed',
    ],
    heading: {
      options: [{
        model: 'paragraph',
        title: 'Paragraph'
      }, {
        model: 'heading1',
        view: 'h1',
        title: 'Heading 1'
      }, {
        model: 'heading2',
        view: 'h2',
        title: 'Heading 2'
      }, {
        model: 'heading3',
        view: 'h3',
        title: 'Heading 3'
      }]
    },
    link: {
      addTargetToExternalLinks: true
      // TODO: test this
      // decorators: {
      //     openInSamePage: {
      //         mode: 'manual',
      //         label: 'Open in same page',
      //         attributes: {
      //             target: '_self',
      //             rel: 'noopener noreferrer',
      //         },
      //     },
      // },
      // allowedProtocols: [ 'https?', 'tel', 'sms', 'mailto' ],
    }
    // mediaEmbed: {
    //     previewsInData: true,
    // },
  },
  ckOptions: null,
  className: null
};
var HtmlField = function HtmlField(_ref) {
  var feedback = _ref.feedback,
    errors = _ref.errors,
    value = _ref.value,
    inline = _ref.inline,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    ckConfig = _ref.ckConfig,
    ckOptions = _ref.ckOptions,
    className = _ref.className;
  var CKEditorBuild = useCKEditorBuild() || null;
  var CKValue = value !== null ? value : '';
  var finalClassName = inline ? classNames([styles.container, 'form-control', _defineProperty(_defineProperty(_defineProperty({}, className, className !== null), 'is-valid', feedback === 'valid'), 'is-invalid', feedback === 'invalid' || errors !== null && errors.length > 0)]) : classNames([styles.container, _defineProperty({}, className, className !== null)]);
  var onCkEditorChange = useCallback(function (event, editor) {
    var data = editor !== null ? editor.getData() : null;
    if (editor !== null && onChange !== null) {
      onChange(data === '' ? null : data);
    }
  }, [onChange]);
  var commonProps = {
    onFocus: onFocus,
    onBlur: onBlur
  };
  var ckElement = CKEditorBuild !== null ? /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, /*#__PURE__*/React.createElement(CKEditor, Object.assign({
    editor: CKEditorBuild,
    data: CKValue,
    config: ckConfig,
    onChange: onCkEditorChange
  }, commonProps, ckOptions, {
    disabled: disabled
  }))) : null;
  return inline ? /*#__PURE__*/React.createElement(InputGroup, null, ckElement) : ckElement;
};
HtmlField.propTypes = propTypes;
HtmlField.defaultProps = defaultProps;

var definition = {
  id: 'html',
  component: 'Html'
};

export { HtmlField as default, definition };
